import { Controller } from "@hotwired/stimulus"

// Formularz reguły automatyzacji: pokazuje sekcje właściwe dla wybranego triggera
// (event/schedule/time_offset/segment); pola ukrytych sekcji są disabled, żeby nie
// wysyłały wartości. Dla triggera segment pobiera podgląd liczby wyników filtra.
export default class extends Controller {
  static targets = ["triggerKind", "eventSection", "scheduleSection", "timeOffsetSection",
    "segmentSection", "segmentSelect", "segmentCount", "hoursSection", "sourceType", "eventSelect"]

  static values = { countUrl: String, resultsLabel: String, events: Object }

  connect() {
    this.toggle()
  }

  toggle() {
    const trigger = this.triggerKindTarget.value
    this.toggleSection(this.eventSectionTarget, trigger === "event")
    this.toggleSection(this.scheduleSectionTarget, trigger === "schedule")
    this.toggleSection(this.timeOffsetSectionTarget, trigger === "time_offset")
    if (this.hasSegmentSectionTarget) {
      this.toggleSection(this.segmentSectionTarget, trigger === "segment")
      if (trigger === "segment") this.refreshSegmentCount()
    }
    // okno godzin tylko dla event/time_offset - przy schedule/segment KIEDY ustala harmonogram,
    // a okno byłoby pułapką (np. harmonogram 9:00 + okno 10-12 = reguła nigdy nie działa)
    if (this.hasHoursSectionTarget) {
      this.toggleSection(this.hoursSectionTarget, trigger === "event" || trigger === "time_offset")
    }
  }

  toggleSection(section, visible) {
    section.hidden = !visible
    section.querySelectorAll("select, input, textarea").forEach((el) => {
      el.disabled = !visible
    })
  }

  // Zdarzenia zależą od modelu źródłowego (Mail::Email: receive/send/update; pozostałe:
  // create/update) - przebudowa selecta zdarzenia po zmianie modelu. Zachowuje bieżącą
  // wartość jeśli nadal dostępna dla nowego modelu.
  sourceTypeChanged() {
    if (!this.hasSourceTypeTarget || !this.hasEventSelectTarget) return
    const options = this.eventsValue[this.sourceTypeTarget.value] || []
    const current = this.eventSelectTarget.value
    this.eventSelectTarget.innerHTML = ""
    options.forEach(([label, value]) => {
      const option = document.createElement("option")
      option.value = value
      option.textContent = label
      if (value === current) option.selected = true
      this.eventSelectTarget.appendChild(option)
    })
  }

  // Podgląd liczby wyników wybranego filtra (pełne wyszukiwanie: pola + warunki) -
  // user widzi skalę zanim zapisze regułę
  async refreshSegmentCount() {
    if (!this.hasSegmentSelectTarget || !this.hasSegmentCountTarget || !this.countUrlValue) return
    const id = this.segmentSelectTarget.value
    this.segmentCountTarget.textContent = ""
    if (!id) return

    // anuluj poprzedni fetch - spóźniona odpowiedź nie nadpisze liczby aktualnego filtra
    this.countAbort?.abort()
    this.countAbort = new AbortController()

    try {
      const res = await fetch(`${this.countUrlValue}.json?segment_id=${encodeURIComponent(id)}`,
        { headers: { Accept: "application/json" }, signal: this.countAbort.signal })
      if (res.ok) {
        const data = await res.json()
        if (data.count != null) this.segmentCountTarget.textContent = `≈ ${data.count} ${this.resultsLabelValue} · `
      }
    } catch { /* podgląd liczby to dodatek - brak nie blokuje formularza */ }
  }
}
